import { render } from "./ProfileEventBody.vue?vue&type=template&id=0e196756&scoped=true"
import script from "./ProfileEventBody.vue?vue&type=script&lang=js"
export * from "./ProfileEventBody.vue?vue&type=script&lang=js"

import "./ProfileEventBody.vue?vue&type=style&index=0&id=0e196756&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e196756"]])

export default __exports__